import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { InfiniteDatasource } from '@/shared/resources/infinite-datasources/infinite-datasource.resource'
import { defaultModeViewAgGrid, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ViewOptions } from '@/shared/models/cruds.models'
import { Nullable } from '@/shared/types/app.types'
import { ColDef, ColGroupDef, ColumnApi, ColumnState, GridApi } from '@ag-grid-enterprise/all-modules'

export interface InfinitePaginatorScrollPage {
    scrollId: Nullable<string>
    size: number
    totalElements: Nullable<number>
}

export interface InfinitePaginatorResponse<T> {
    content: T[]
    scrollPage: InfinitePaginatorScrollPage
}

export interface InfinitePaginatorResourceService<T> {
    paginator(filterModel: CommonFilterModel, params: CommonParams, ...restOfParams: any[]): Promise<InfinitePaginatorResponse<T>>
}

export interface CrudModelBaseInfinite<T> {
    actionTitle: string
    gridUiComponent: string
    selectedRows: T[]
    clickedRow?: Nullable<T>
    columnsDef?: (ColDef | ColGroupDef | ExportedColDef | ExportedColGroupDef)[]
    gridApi: Nullable<GridApi>
    columnApi: Nullable<ColumnApi>
    datasource: InfiniteDatasource<T>
    rowData?: []
    visibleSidePanel?: boolean
    viewOptions: ViewOptions
    totalElements: Nullable<number>
    elementsByPage: number
    updateGrid: string
    columnsState: Nullable<ColumnState[]>

}
export function initialInfiniteState<T>(): CrudModelBaseInfinite<T> {
    return {
        actionTitle: '',
        gridUiComponent: '',
        selectedRows: [],
        clickedRow: null,
        columnsDef: [],
        gridApi: null,
        columnApi: null,
        datasource: new InfiniteDatasource<T>(null),
        rowData: [],
        viewOptions: {
            modeView: { ...defaultModeViewAgGrid }
        },
        totalElements: null,
        elementsByPage: 20,
        updateGrid: '',
        columnsState: null
    }
}
